var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNewImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 0.75C0 0.335786 0.335786 0 0.75 0H9C9.41421 0 9.75 0.335786 9.75 0.75C9.75 1.16421 9.41421 1.5 9 1.5H1.5V16.5H16.5V8.68182C16.5 8.2676 16.8358 7.93182 17.25 7.93182C17.6642 7.93182 18 8.2676 18 8.68182V17.25C18 17.6642 17.6642 18 17.25 18H0.75C0.335786 18 0 17.6642 0 17.25V0.75Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.25 5.75v3.5c0 .41.34.75.75.75s.75-.34.75-.75v-3.5h3.5c.41 0 .75-.34.75-.75s-.34-.75-.75-.75h-3.5V.75c0-.41-.34-.75-.75-.75s-.75.34-.75.75v3.5h-3.5c-.41 0-.75.34-.75.75s.34.75.75.75h3.5Z",
    fill: "currentColor",
    className: "accent"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.96967 7.46967C4.26256 7.17678 4.73744 7.17678 5.03033 7.46967L9.5 11.9393L10.9697 10.4697C11.2626 10.1768 11.7374 10.1768 12.0303 10.4697L17.0303 15.4697C17.3232 15.7626 17.3232 16.2374 17.0303 16.5303C16.7374 16.8232 16.2626 16.8232 15.9697 16.5303L11.5 12.0607L10.5607 13L14.0303 16.4697C14.3232 16.7626 14.3232 17.2374 14.0303 17.5303C13.7374 17.8232 13.2626 17.8232 12.9697 17.5303L4.5 9.06066L1.53033 12.0303C1.23744 12.3232 0.762563 12.3232 0.46967 12.0303C0.176777 11.7374 0.176777 11.2626 0.46967 10.9697L3.96967 7.46967Z",
    fill: "currentColor",
    className: "accent"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewImage);
export default __webpack_public_path__ + "static/media/new-image.3bb4fa51cfbec9e3b958559b10e8f214.svg";
export { ForwardRef as ReactComponent };